import React from "react";

const WingProfile = ({
  width,
  depth,
  height,
  position,
  color,
  isDouble,
  flip = false,
  direction,
  isKol
}) => {
  const boxHeight = height * (isDouble ? 1 : 0.5);
  const cylinderRadius = height * 0.5;
  const cylinderHeight = width;
  const capThickness = 0.02;
  const shouldShowLock = ((direction == 1 || direction == 4) && !isKol);

  return (
    <group position={position}>
      {/* Düz kutusal kısım */}
      <mesh position={[0, flip ? -boxHeight / 2 : boxHeight / 2, 0]}>
        <boxGeometry args={[width, boxHeight, depth]} />
        <meshStandardMaterial color={color} />
      </mesh>

      {/* Kapaklar - kutunun sağ ve soluna */}
      {!isDouble && (
        <>
          <mesh position={[-width / 2 - capThickness / 2, flip ? -boxHeight / 2 : boxHeight / 2, 0]}>
            <boxGeometry args={[capThickness, boxHeight, depth]} />
            <meshStandardMaterial color="black" />
          </mesh>
          <mesh position={[width / 2 + capThickness / 2, flip ? -boxHeight / 2 : boxHeight / 2, 0]}>
            <boxGeometry args={[capThickness, boxHeight, depth]} />
            <meshStandardMaterial color="black" />
          </mesh>
        </>
      )}

      {/* Oval yarım silindir kısım */}
      {!isDouble && (
        <mesh
          position={[0, flip ? -cylinderRadius : cylinderRadius, 0]}
          rotation={[0, 0, flip ? -Math.PI / 2 : Math.PI / 2]}
        >
          <cylinderGeometry
            args={[cylinderRadius - 0.005, cylinderRadius - 0.005, cylinderHeight, 32, 1, false, 0, Math.PI]}
          />
          <meshStandardMaterial color={color} />
        </mesh>
      )}

      {/* Silindir kapaklar */}
      {!isDouble && (<mesh
        position={[-width / 2 - capThickness / 2, flip ? -cylinderRadius : cylinderRadius, 0]}
        rotation={[0, 0, flip ? -Math.PI / 2 : Math.PI / 2]}
      >
        <cylinderGeometry args={[cylinderRadius - 0.005, cylinderRadius - 0.005, capThickness, 32]} />
        <meshStandardMaterial color="black" />
      </mesh>)}

      {!isDouble && (<mesh
        position={[width / 2 + capThickness / 2, flip ? -cylinderRadius : cylinderRadius, 0]}
        rotation={[0, 0, flip ? -Math.PI / 2 : Math.PI / 2]}
      >
        <cylinderGeometry args={[cylinderRadius - 0.005, cylinderRadius - 0.005, capThickness, 32]} />
        <meshStandardMaterial color="black" />
      </mesh>
      )}

      {/* Kilit görseli */}
      {shouldShowLock && (
        <mesh position={[(direction==4 ? width / 2 - 0.18 : -width / 2 + 0.18) , height-(flip ? 0.08 : 0.04) , -0.02]}>
          <boxGeometry args={[0.04, 0.04, 0.02]} />
          <meshStandardMaterial color="black" />
        </mesh>
      )}
    </group>
  );
};

export default WingProfile;